import React from 'react'

function MoreInfoLabel() {
  return (
    <span>
      More Info
      <i className="fa-regular fa-folder-open text-brand d-inline-block ps-1"></i>
    </span>
  )
}

export default MoreInfoLabel
